import { useLayoutEffect } from 'react';

let lockCount = 0;
let originalOverflow = '';
let originalPaddingRight = '';

export const useBodyScrollLock = () => {
    useLayoutEffect(() => {
        if (lockCount === 0) {
            const bodyStyle = window.getComputedStyle(document.body);
            originalOverflow = bodyStyle.overflow;
            originalPaddingRight = bodyStyle.paddingRight;

            const scrollbarWidth = window.innerWidth - document.documentElement.clientWidth;
            if (scrollbarWidth > 0) {
                document.body.style.paddingRight = `${parseFloat(originalPaddingRight || '0') + scrollbarWidth}px`;
            }
        }
        document.body.style.overflow = 'hidden';
        lockCount++;

        return () => {
            lockCount--;
            if (lockCount === 0) {
                document.body.style.overflow = originalOverflow;
                document.body.style.paddingRight = originalPaddingRight;
            }
        };
    }, []);
};
